/*@ngInject*/
const ObjectRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getObjectNames = function (matchingName) {
        var url = '/rest/Object/';
        return this.get(url);
    };

    this.getObjectPropertyValues = function (objectName) {
        var url = '/rest/Object/' + objectName;
        return this.get(url);
    };

};

angular.module('ums.configuration')
    .service('objectRepository', ObjectRepository);
